export const FrLocale = {
    page: {
        txtTitle: 'UNVOX | Supprimez les voix instantanément',
    },
    global: {
        brand: {
            txtName: 'unvox.ai',
            txtLogoAlt: 'logo unvox',
        },
        action: {
            txtBack: 'Retour',
            txtRetry: 'Réessayer',
            txtStartOver: 'Recommencer',
        },
        job: {
            txtCheckingStatus: 'Vérification du statut du job',
            txtIdLabel: 'ID du job',
        },
        footer: {
            linkPrivacyPolicy: 'Politique de confidentialité',
            linkTerms: 'Conditions',
            linkRefunds: 'Remboursements',
            linkSupport: 'Support',
            txtAllRightsReserved: 'Tous droits réservés.',
            txtBugReportsAndFeatures: 'Rapports de bugs et demandes de fonctionnalités',
        },
        share: {
            title: 'UNVOX | Suppression des voix de chanson en un clic',
            text: 'Transformez facilement vos chansons préférées en instrumentales prêtes pour le karaoké.',
        },
    },
    route: {
        home: {
            txtHeroKicker: '',
            txtHeroTitle: 'Suppression vocale en un clic',
            txtHeroSubtitle: 'Instrumentales instantanées depuis votre piste ou directement depuis YouTube',
            txtInputTypeLabel: 'Type de source',
            txtInputTypeFile: 'Téléverser un fichier audio',
            txtInputTypeYoutube: 'Lien YouTube',
            txtInputFilePick: 'Choisir un fichier',
            txtInputFileSub: 'Formats audio courants ({{formats}}), jusqu\'à {{size}} MB.',
            txtPreviewAction: 'Supprimer les voix',
            txtPreviewFailed: 'Une erreur inconnue est survenue. Veuillez réessayer plus tard.',
            txtUploadSelectFile: 'Aucun fichier sélectionné pour le moment',
            txtYoutubeLabel: 'URL YouTube',
            txtYoutubePlaceholder: 'https://youtube.com/watch?v=...',
            txtYoutubeHelper: 'Collez un lien YouTube public.',
            txtYoutubeMissing: 'Veuillez coller une URL YouTube.',
            txtYoutubeInvalid: 'Saisissez une URL YouTube valide.',
            txtYoutubeTooLong: 'Cette vidéo dure plus de 15 minutes. Veuillez choisir une vidéo plus courte.',
            txtCheckoutUploadFailed: 'Le téléversement a échoué. Veuillez réessayer.',
            txtUploadMissing: 'Veuillez choisir un fichier avant de téléverser.',
            txtFileTypeInvalid: 'Type de fichier non pris en charge. Veuillez téléverser un fichier audio (ex. {{formats}}).',
            txtFileTooLarge: 'Le fichier est trop volumineux. Taille max : {{size}} MB.',
        },
        previewJob: {
            txtUnavailableTitle: 'Impossible de créer l\'aperçu',
            txtUnavailableBody: 'Une erreur inconnue est survenue. Veuillez réessayer plus tard.',
            txtPreparingTitle: 'Préparation de l\'aperçu',
            txtPreparingBody: 'Cela peut prendre jusqu\'à 2 minutes',
        },
        payment: {
            txtUnavailableTitle: 'Impossible de créer l\'aperçu',
            txtUnavailableBody: 'Une erreur inconnue est survenue. Veuillez réessayer plus tard.',
            txtPreparingTitle: 'Préparation de l\'aperçu',
            txtCheckoutCancelledBody: 'Aucun montant n\'a été débité. Vous pouvez réessayer à tout moment.',
            txtTrackPreviewLabel: 'Aperçu de la piste',
            txtTrackPreviewHelper: 'Cet aperçu est un extrait de 15 secondes de votre piste pour évaluation',
            txtEmailLabel: 'Adresse e-mail',
            txtEmailPlaceholder: 'yourname@email.com',
            txtEmailCheckoutHelper: 'Nous utiliserons cette adresse pour envoyer votre lien de téléchargement.',
            txtCheckoutAction: 'Supprimer les voix pour seulement {{price}}',
            txtCheckoutActionFallback: 'Supprimer les voix',
            txtCheckoutFailed: 'Impossible de démarrer le paiement. Veuillez réessayer.',
            txtInvalidEmail: 'Saisissez une adresse e-mail valide.',
        },
        processing: {
            txtMissingTitle: 'ID du job manquant',
            txtMissingBody: 'Cette page nécessite un ID de job. Veuillez démarrer un nouvel aperçu.',
            txtMissingAction: 'Retour au téléversement',
            txtStatusFailed: 'Impossible de récupérer le statut du job. Veuillez réessayer.',
            txtErrorTitle: 'Un problème est survenu',
            txtSupportAction: 'Contacter le support',
            txtConfirmingTitle: 'Confirmation du paiement',
            txtConfirmingBody: 'Confirming payment status',
            txtPolling: 'Recherche de mises à jour',
            txtWorkingTitle: 'Traitement de votre piste complète',
            txtWorkingBody: 'This will take a few minutes. You will receive an email when the track is ready.',
            txtWorkingAction: 'Démarrer un autre',
            txtReadyTitle: 'Téléchargement prêt',
            txtReadyBody: 'Votre instrumental est prêt à être téléchargé.',
            txtDownloadAction: 'Télécharger',
            txtDownloadNote: 'This download link expires in 72 hours and will be emailed to you.',
            txtReadyAction: 'Démarrer un autre',
        },
        invalidJob: {
            txtTitle: 'ID du job invalide',
            txtBody: 'Ce job est introuvable. Veuillez démarrer un nouveau téléversement.',
            txtAction: 'Recommencer',
        },
        refund: {
            txtEyebrow: 'Legal',
            txtTitle: 'Refund Policy',
            txtLastUpdatedLabel: 'Last updated',
            txtLastUpdatedDate: 'February 17, 2026',
            txtIntro: 'All purchases are final. We do not issue refunds.',
            txtSectionServiceErrorsTitle: 'Service Errors and Reprocessing',
            txtSectionServiceErrorsBody: 'We want our users to be satisfied with the Service. If an error occurs on our side, we will reprocess your files at no additional cost.',
            txtServiceErrorsItemJobFailed: 'If a job fails due to a technical issue in the Service, we will rerun it.',
            txtServiceErrorsItemDeliveryFailed: 'If output delivery fails due to our systems, we will redeliver your results.',
            txtSectionHelpTitle: 'How to Request Help',
            txtSectionHelpBody: 'Contact Support and include your job ID and the email address you used at checkout. We may ask for additional details to diagnose and reprocess your job.',
            txtNoRefundsNote: 'No refunds will be issued.',
        },
        support: {
            txtEyebrow: 'Support',
            txtTitle: 'Contacter le support',
            txtLastUpdatedLabel: 'Dernière mise à jour',
            txtLastUpdatedDate: '9 février 2026',
            txtSectionEmailTitle: 'E-mail',
            txtSectionEmailBodyPrefix: 'Écrivez-nous à',
            txtSectionIncludeJobIdTitle: 'Incluez votre ID de job',
            txtSectionIncludeJobIdBody: 'Veuillez inclure votre ID de job pour que nous puissions le retrouver rapidement. Si vous avez payé, incluez l\'adresse e-mail utilisée au paiement.',
            txtSectionBugReportsTitle: 'Rapports de bugs',
            txtSectionBugReportsBody: 'Vous pouvez aussi envoyer des rapports de bugs et des demandes de fonctionnalités via le lien dans le pied de page.',
        },
        bugReportsFeatures: {
            txtEyebrow: 'Retour',
            txtTitle: 'Rapports de bugs et demandes de fonctionnalités',
            txtSubtitle: 'UNVOX est encore jeune. Si quelque chose semble incorrect ou si vous avez une idée, envoyez-la. Des rapports clairs sont le moyen le plus rapide d\'expédier des correctifs.',
            txtWhatToIncludeTitle: 'À inclure',
            txtChecklistExpectedVsActual: 'Ce que vous attendiez vs ce qui est arrivé',
            txtChecklistSteps: 'Étapes pour reproduire (1, 2, 3)',
            txtChecklistBrowserOs: 'Votre navigateur et votre OS',
            txtChecklistJobId: 'ID du job (si cela concernait un téléversement)',
            txtTipTitle: 'Astuce',
            txtTipBody: 'Si vous nous contactez par e-mail, vous pouvez répondre directement au mail de livraison reçu et coller le modèle.',
            txtTemplateTitle: 'Modèle à copier-coller',
            txtTemplateBody: 'Rapport de bug / Demande de fonctionnalité\n\nType : bug | fonctionnalité\nRésumé :\n\nDétails :\n- Ce qui est arrivé :\n- Ce que vous attendiez :\n- Étapes pour reproduire :\n  1.\n- Navigateur/OS :\n\nOptionnel :\n- ID du job :\n- URL YouTube :\n- Capture d\'écran/vidéo :\n',
            txtTemplatePageLabel: 'Page',
            txtTemplateUserAgentLabel: 'Agent utilisateur',
            txtCopyActionIdle: 'Copier le modèle',
            txtCopyActionCopied: 'Copié',
            txtCopyActionFailed: 'Échec de la copie',
            txtCopyHelpFailed: 'L\'accès au presse-papiers a été bloqué. Vous pouvez quand même sélectionner le texte ci-dessus et le copier manuellement.',
            txtCopyHelpIdle: 'Rien ici n\'est envoyé automatiquement. Cette page vous aide seulement à formater un bon rapport.',
        },
    },
};
